import { getPromotionLabel } from './promotionLabel';

// Map API promotion types to the SAME i18n keys the DP Evo result-page badges use (MPH-721),
// so both pages speak with one voice. Keyed by the uppercased API `type` (same convention as
// promotionLabel.ts). Types without a result-page equivalent keep the API label.
export const PROMOTION_LABEL_TRANSLATION_KEYS: Record<string, string> = {
  TICKETS_INCLUDED: 'vacation.oss.cards.tickets_included',
  SPA_INCLUDED: 'vacation.oss.cards.spa_included',
  SKI_PASS_INCLUDED: 'vacation.oss.cards.ski_pass_included',
  RESORT_CREDIT: 'vacation.oss.cards.usp.resort_credits',
  TRANSFER_INCLUDED: 'vacation.oss.cards.flights.transfer_included',
  WELCOME_GIFT_OFFER: 'vacation.oss.cards.welcome_gift',
};

export function getPromotionDisplayLabel(
  promotion: { type: string; label: string },
  t: (key: string) => string
): string {
  const key = PROMOTION_LABEL_TRANSLATION_KEYS[promotion.type.toUpperCase()];
  const translated = key ? t(key) : '';
  // t() returns '' when the key is missing from the market's CMS dictionary. Falling back through
  // getPromotionLabel keeps the CHILDREN_FREE_OFFER copy aligned where that type renders inline
  // (e.g. cancellation options); every other type resolves to the API label.
  return translated || getPromotionLabel(promotion, t);
}
